import Vue from 'vue'
import qs from 'qs'

import Router from 'vue-router'
import Login from '@/views/auth/Login'
import Layout from '@/views/layout/Layout'

import Dashboard from '@/views/Dashboard'
import Settings from '@/views/Settings'

import Pages from '@/views/page/Index'
import CreatePage from '@/views/page/Create'
import EditPage from '@/views/page/Edit'

import Categories from '@/views/category/Index'
import CreateCategory from '@/views/category/Create'
import EditCategory from '@/views/category/Edit'

import Navigations from '@/views/navigation/Index'
import CreateNavigation from '@/views/navigation/Create'
import EditNavigation from '@/views/navigation/Edit'

import Sliders from '@/views/slider/Index'
import CreateSlider from '@/views/slider/Create'
import EditSlider from '@/views/slider/Edit'

import Users from '@/views/user/Index'
import CreateUser from '@/views/user/Create'
import EditUser from '@/views/user/Edit'

import Screens from '@/views/screen/Index'
import CreateScreen from '@/views/screen/Create'
import EditScreen from '@/views/screen/Edit'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { isGuest: true }
    },
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: { name: 'dashboard' },
      meta: { isAdmin: true },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/content/:typeId/',
          name: 'pages.index',
          component: Pages,
          children: [
            {
              path: '/content/:typeId/create',
              name: 'pages.create',
              component: CreatePage
            },
            {
              path: '/content/:typeId/:id',
              name: 'pages.edit',
              component: EditPage
            }
          ]
        },
        {
          path: '/categories',
          name: 'categories.index',
          component: Categories,
          children: [
            {
              path: '/categories/create',
              name: 'categories.create',
              component: CreateCategory
            },
            {
              path: '/categories/:id',
              name: 'categories.edit',
              component: EditCategory
            }
          ]
        },
        {
          path: '/settings',
          name: 'settings',
          component: Settings
        }, {
          path: '/navigations',
          name: 'navigations.index',
          component: Navigations,
          children: [
            {
              path: '/navigations/create',
              name: 'navigations.create',
              component: CreateNavigation
            },
            {
              path: '/navigations/:id',
              name: 'navigations.edit',
              component: EditNavigation
            }
          ]
        }, {
          path: '/sliders',
          name: 'sliders.index',
          component: Sliders,
          children: [
            {
              path: '/sliders/create',
              name: 'sliders.create',
              component: CreateSlider
            },
            {
              path: '/sliders/:id',
              name: 'sliders.edit',
              component: EditSlider
            }
          ]
        }, {
          path: '/users',
          name: 'users.index',
          component: Users,
          children: [
            {
              path: '/users/create',
              name: 'users.create',
              component: CreateUser
            },
            {
              path: '/users/:id',
              name: 'users.edit',
              component: EditUser
            }
          ]
        }, {
          path: '/screens',
          name: 'screens.index',
          component: Screens,
          children: [
            {
              path: '/screens/create',
              name: 'screens.create',
              component: CreateScreen
            },
            {
              path: '/screens/:id',
              name: 'screens.edit',
              component: EditScreen
            }
          ]
        }
      ]
    }
  ],
  parseQuery (query) {
    return qs.parse(query)
  },
  stringifyQuery (query) {
    var result = qs.stringify(query)

    return result ? ('?' + result) : ''
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js